import { render } from "./voperatuser.vue?vue&type=template&id=b23b35f6&scoped=true"
import script from "./voperatuser.vue?vue&type=script&lang=js"
export * from "./voperatuser.vue?vue&type=script&lang=js"

import "./voperatuser.vue?vue&type=style&index=0&id=b23b35f6&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b23b35f6"]])

export default __exports__